var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGreenLoanClean48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95215 20.0315V39.8338C9.95215 40.5709 10.5265 41.1685 11.235 41.1685H38.3342C39.0427 41.1685 39.617 40.5709 39.617 39.8338V20.0315C39.617 19.6429 39.4542 19.2736 39.1711 19.02L25.6215 6.88279C25.1404 6.45183 24.4287 6.45183 23.9476 6.88279L10.398 19.02C10.115 19.2736 9.95215 19.6429 9.95215 20.0315Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7749 6.03711L38.9575 16.1525",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "6 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8481 21.2109V22.9892",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0698 21.2109V22.9892",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4653 34.4428H31.6979C32.8025 34.4428 33.6979 33.5474 33.6979 32.4428V26.749",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6264 23.1893C36.6264 23.0788 36.5368 22.9893 36.4264 22.9893H31.4915C31.3811 22.9893 31.2915 23.0788 31.2915 23.1893V24.4712C31.2915 25.617 32.4858 26.5458 33.959 26.5458C35.4321 26.5458 36.6264 25.617 36.6264 24.4712V23.1893Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83057 37.0029H12.4716V39.3436C12.4716 40.349 11.6566 41.1641 10.6511 41.1641C9.64566 41.1641 8.83057 40.349 8.83057 39.3436V37.0029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3145 37.0029H24.9556V39.3436C24.9556 40.349 24.1405 41.1641 23.135 41.1641C22.1295 41.1641 21.3145 40.349 21.3145 39.3436V37.0029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5079 26.4644L9.375 30.2407H24.7197L23.5868 26.4644C23.3331 25.6185 22.5544 25.0391 21.6712 25.0391H12.4235C11.5403 25.0391 10.7617 25.6185 10.5079 26.4644Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0362 37.7831H6.75V33.3618C6.75 30.657 9.3508 29.8074 10.6512 29.7207H23.135C26.256 29.7207 27.0362 32.1481 27.0362 33.3618V37.7831Z",
    fill: "#1A7D1A",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.992 33.8818C12.992 34.7437 12.2933 35.4423 11.4317 35.4423C10.5698 35.4423 9.87109 34.7437 9.87109 33.8818C9.87109 33.0199 10.5698 32.3213 11.4317 32.3213C12.2933 32.3213 12.992 33.0199 12.992 33.8818Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9154 33.8818C23.9154 34.7437 23.2167 35.4423 22.355 35.4423C21.4931 35.4423 20.7944 34.7437 20.7944 33.8818C20.7944 33.0199 21.4931 32.3213 22.355 32.3213C23.2167 32.3213 23.9154 33.0199 23.9154 33.8818Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGreenLoanClean48);
export default __webpack_public_path__ + "static/media/pictogramBeaconGreenLoanClean48.3ea6a67dfbffe7e6e816ebff5c6996fa.svg";
export { ForwardRef as ReactComponent };